<!--element 历史事件-->
<template>
  <div class="myelEventBody">
    <div class="con">
      <!-- <div class="page_top_form">
          <el-form ref="form" label-width="80px">
            <el-form-item label="事件类型">
              <el-select v-model="form.eventType" multiple collapse-tags style="margin-left: 10px;" placeholder="请选择">
                <el-option label='全选' value='全选' @click.native='selectAll'></el-option>
                <el-option v-for="item in getEventTypes" :key="item.id" :label="item.name" :value="item.no">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <el-date-picker v-model="form.dataTime" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="margin-left: 10px;" @click="searchEvents()" icon="el-icon-search"
                plain>查询</el-button>
            </el-form-item>
          </el-form>
        </div> -->
      <div class="Files-top">
        <div class="ic-left">
          <span>历史事件</span>
        </div>
        <div class="btns">
        </div>
      </div>
      <div class="search-input-btn" style="width:100%">
        <div class="input-small mr-20">
          <span>事件类型：</span>
          <el-select v-model="form.eventType" multiple collapse-tags placeholder="请选择">
            <el-option label='全选' value='全选' @click.native='selectAll'></el-option>
            <el-option v-for="item in getEventTypes" :key="item.id" :label="item.name" :value="item.no">
            </el-option>
          </el-select>
        </div>
        <div class="input-small myinput">
          <span>时间：</span>
          <el-date-picker v-model="form.dataTime" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>

        <el-button type="primary" @click="searchEvents" class="search-btn">查询</el-button>
      </div>

      <div class="elEvent_bottom" :style="{'height':tabHeights+'px'}">
        <el-table :data="eventList" style="width: 100%" border :height="tabHeights - 20" v-loading="loading">
          <el-table-column label="序号" width="90" align="center">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkobject" label="关联对象" width="200">
          </el-table-column>
          <!-- <el-table-column prop="eventlevel" label="等级" width="100" align="center" :formatter="formatEventLevel">
            </el-table-column> -->
          <el-table-column label="等级" width="105" align="center">
            <template #default="{row}">
              <div class="public-flex">
                <p class="myemergent mutongyong" v-if="row.eventlevel =='0'">消息</p>
                <p class="myhigh mutongyong" v-if="row.eventlevel =='1'">预警</p>
                <p class="mystandard mutongyong" v-if="row.eventlevel =='2'">告警</p>
                <p class="mylow mutongyong" v-if="row.eventlevel =='3'">通知</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="typeName" label="事件类型" width="115" align="center">
          </el-table-column>
          <el-table-column prop="time" label="时间" :formatter="formatTime">
          </el-table-column>
          <el-table-column prop="description" label="内容" width="320">
          </el-table-column>
          <!-- <el-table-column prop="eventstate" label="状态" width="130" align="center" :formatter="formatterEventState">
            </el-table-column> -->
          <el-table-column label="状态" width="105" align="center">
            <template #default="{row}">
              <div class="patrol public-flex" v-if="row.eventstate =='3'">
                <p></p><span>已确认</span>
              </div>
              <div class="overhaul public-flex" v-else>
                <p></p><span>未处理</span>
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="confirmuser" label="确认人">
          </el-table-column>
          <el-table-column prop="confirmtime" label="确认时间" :formatter="formatTimeConfirm">
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="confirmEvent(scope.row)" style="color:#368ED9">确认事件</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <!-- <elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange"
            @handleSizeChange="handleSizeChange" /> -->
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="currentPage" :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    props: {},
    data () {
      return {
        tabHeights: document.getElementById('app').clientHeight-280,
        form: {
          eventType: "",
          dataTime: [new Date(),new Date()],
        },
        eventList: [],
        state: -1,
        currentPage: 1,
        currentSize: 20,
        total: 0,
        loading: false,
      }
    },
    created () {},
    mounted () {
      debugPage=this
      //默认全选
      this.form.eventType[0]="全选"
      this.selectAll()
      this.searchEvents()
    },
    destroyed () {},
    computed: {
      eventStore () {
        return this.$store.eventStore
      },
      getEventTypes () {
        return this.eventStore.getters.searchAllEventTypes
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      getLevelName () {
        return this.$store.eventStore.getters.getLevelName
      },
      getStateName () {
        return this.$store.eventStore.getters.getStateName
      },
    },
    watch: {
      eventList (nv,ov) {
        console.log("数据",nv);
      }
    },
    methods: {
      formatEventLevel (row,column,cellValue) {
        return this.getLevelName(row.eventlevel)
      },
      formatterEventState (row,column,cellValue) {
        return this.getStateName(row.eventstate)
      },
      formatTime (row,column,cellValue) {
        return new Date(row.time).format('yyyy/MM/dd hh:mm:ss')
      },
      formatTimeConfirm (row,column,cellValue) {
        if(!isempty(row.confirmtime)) {
          return new Date(row.confirmtime).format('yyyy/MM/dd hh:mm:ss')
        }
      },
      selectAll () {
        if(this.form.eventType[0]=="全选") {
          this.getEventTypes.forEach(item => {
            this.form.eventType.push(item.no)
          })
        } else {
          this.form.eventType=[]
        }
      },
      //分页功能 
      handleSizeChange (val) {
        this.currentSize=val;
        this.searchEvents()
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.searchEvents()
      },
      confirmEvent (row) {
        //确认事件
        this.$api.eventApi.confirmEventByEventNo(row.no,respon => {
          this.$message.success("确认成功")
          this.searchEvents()
        },respon => {
          this.$message.warning("确认失败")
        })
      },
      searchEvents () {
        //查询事件
        if(isempty(this.form.eventType)) {
          //事件类型为空
          this.$message.warning("事件类型不能为空")
          return
        }
        let eventTypeNos=""
        //bgTime变成0点0秒
        let y=this.form.dataTime[0].getFullYear();
        let m=this.form.dataTime[0].getMonth();
        let d=this.form.dataTime[0].getDate();
        let bgTime=new Date(y,m,d).getTime();
        //let bgTime = this.form.dataTime[0].getTime()
        //把0点0分变成23点59
        let endTime=this.form.dataTime[1].getTime()+60*60*24*1000-1
        this.form.eventType.forEach((item,index) => {
          if(item!="全选") {
            index+1<this.form.eventType.length? eventTypeNos+=item+",":eventTypeNos+=item
          }
        })
        this.loading=true
        this.$api.eventApi.searchEventListByUser(undefined,this.nowUnit.id,eventTypeNos,this.state,-1,getValueIfNoNull(this.nowDevice,{}).no,bgTime,endTime,this.currentPage,this.currentSize,'',respon => {
          this.total=respon.total
          this.eventList=respon.data
          this.loading=false
        })
      },
    }
  }
</script>

<style scoped lang='scss'>
  .myelEventBody {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      background-color: #fff;
      padding: 12px 20px 20px 20px;

    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    // 巡检
    .patrol {
      p {
        width: 8px;
        height: 8px;
        background-color: #0DAE88;
        border-radius: 50%;
        margin-right: 8px;
        position: relative;
        top: -1px;
      }

      span {
        color: #0DAE88;
      }
    }

    // 检修
    .overhaul {
      p {
        width: 8px;
        height: 8px;
        background-color: #FF1D1D;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #FF1D1D;
      }
    }

    .mutongyong {
      width: 36px;
      height: 20px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
    }

    //消息
    .myemergent {
      border: 1px solid #2981D2;
      color: #2981D2;
      background-color: #DEF3FF;
    }

    //预警
    .myhigh {
      border: 1px solid #FF7C1D;
      color: #FF7C1D;
      background-color: #FFF1E7;
    }

    //告警
    .mystandard {
      border: 1px solid #ED6547;
      color: #ED6547;
      background-color: #FFECEC;
    }

    //通知
    .mylow {
      border: 1px solid #0DAE88;
      color: #0DAE88;
      background-color: #8EF9DF;
    }
  }
</style>